export const seoKeywords = {
  name: 'keywords',
  content:
    'blockchain, software development, outsourcing, software house, nodejs, solidity, solana, react js, react native, truffle, ethereum',
};

export const careersSeo = {
  title:
    'User Experience and User Interface design services | Rumble Fish Software Development',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'User experience design services tailored to your needs. User interface design in line with industry standards and best practices. Make your product pop with our help!',
    },
  ],
};
